import { combineReducers } from 'redux';

import actionRoles from 'actions/actionRolesSlice';

import dynamicListData from 'components/list/dynamicListSlice';

import connectedTokens from 'pages/APIIntegrations/ConnectedTokens.slice';
import register from 'pages/Login/registerSlice';
import otoLinkSettings from 'pages/OTOLink/OTOLinkSettings/OtoLinkSettingsSlice';
import otoPackageList from 'pages/OTOModules/OTOPackageListSlice';
import otoStore from 'pages/OTOStore/OTOStoreSlice';
import connectedIntegrations from 'pages/OtherIntegrations/ConnectedIntegrations/ConnectedIntegrationsSlice';
import whatsappBusiness from 'pages/OtherIntegrations/Integrations/Modals/WhatsappBusiness/whatsappBusinessSlice';
import integrationsStores from 'pages/OtherIntegrations/Integrations/integrationsStoresSlice';
import productGroupList from 'pages/Products/Products/productGroupsSlice';
import connectedStores from 'pages/SalesChannels/ConnectedStores/ConnectedStores.slice';
import salla from 'pages/SalesChannels/ConnectedStores/Salla.slice';
import onlineStores from 'pages/SalesChannels/OnlineStores/onlineStoresSlice';
import salesChannel from 'pages/SalesChannels/salesChannelDetailsSlice';
import subscriptionAccount from 'pages/Settings/Payment/SubscriptionAccount/SubscriptionAccountSlice';
import printSettings from 'pages/Settings/Print/PrintSettingsSlice';
import smsProviders from 'pages/Settings/SMS/SMSProviders/smsProvidersSlice';
import shipmentResults from 'pages/Shipments/ActionForms/CreateShipment/shipmentResultsSlice';
import aggregatorAging from 'pages/Shipments/Operation/AggregatorAging/AggregatorAgingSlice';
import connectedPartners from 'pages/ShippingPartners/ConnectedPartners/ConnectedPartnersSlice.list';
import morePartners from 'pages/ShippingPartners/MoreConnection/MorePartnersSlice.list';
import shippingPartners from 'pages/ShippingPartners/ShippingPartnersSlice';
import chargeAccount from 'pages/Topbar/ChargeAccount/ChargeAccountSlice';
import notifications from 'pages/Topbar/Notifications/notificationsSlice';

import instruction from 'stores/InstructionSlice';
import globalAddress from 'stores/globalAddressSlice';
import modals from 'stores/modalsSlice';

import layout from './layoutSlice';
import mapsConfig from './mapsConfigSlice';
import systemRoles from './systemRolesSlice';
import user from './userSlice';
import videoPopup from './videoSlice';

// Combine all reducers into 1 appReducer
const appReducer = combineReducers({
	/*
	 * CORE REDUCERS
	 */
	user,
	layout,
	modals,
	instruction,
	mapsConfig,
	dynamicListData,
	systemRoles,
	actionRoles,
	globalAddress,
	printSettings,
	register,
	notifications,
	videoPopup,

	/*
	 * FEATURE REDUCERS
	 */
	chargeAccount,
	subscriptionAccount,
	otoPackageList,
	shipmentResults,
	productGroupList,
	connectedPartners,
	connectedStores,
	salla,
	morePartners,
	connectedIntegrations,
	whatsappBusiness,
	integrationsStores,
	onlineStores,
	aggregatorAging,
	shippingPartners,
	salesChannel,
	otoLinkSettings,
	otoStore,
	connectedTokens,
	smsProviders
});

export default (state, action) => appReducer(state, action);
